import React from "react";
import parse from "html-react-parser";
import {clsx} from "clsx";

const TableLegend = ({data, showSpecials, showOrderButton}) => {
    return (
        <thead key={'product_details_head_legend'}>
            <tr key={'product_details_head_legend_tr'}>
                {
                    Object.values(data.legend).map((tr, index) => {
                        const title = tr?.title ? parse(tr.title) : '';

                        if(title === 'Bestellen' && showSpecials && !showOrderButton) {
                            return null;
                        }
                        const action = tr?.action ? parse(tr.action) : '';
                        if (showSpecials ||
                            !['only_for_users'].includes(action)
                        ) {
                          const classTd = clsx(index === 0 ? 'sticky-head-col' : '');

                            return (
                                <td key={`product_details_head_legend_tr_td_${index}`}
                                    className={classTd}
                                    scope="col"
                                    colSpan="1">
                                    {title}
                                </td>
                            )
                        }
                        return null;
                    })
                }
            </tr>
        </thead>
    )
}

export default TableLegend;
